import React from 'react';
import { WidgetSliderSlide } from '../types';
import { JRCTypography } from '../../../JRCTypography/JRCTypography';

export const SliderSlideTitle = ({ title, titleHeading }: Pick<WidgetSliderSlide, 'title' | 'titleHeading'>) => {
    return <JRCTypography variant={titleHeading}>{title}</JRCTypography>;
};
